import { IconProps } from "@/src/sb/business-layer/types"
import React from "react"

const ReportsIcon = ({ width, height, size }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? width ?? "12"}
    height={size ?? height ?? "12"}
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.75 9.50014H5.125V10.3751H0.75V9.50014ZM0.75 6.8751H5.125V7.7501H0.75V6.8751ZM10.375 5.125H1.625C1.14175 5.125 0.75 4.73325 0.75 4.25V1.625C0.75 1.14175 1.14175 0.75 1.625 0.75H10.375C10.8582 0.75 11.25 1.14175 11.25 1.625V4.25C11.25 4.73325 10.8582 5.125 10.375 5.125ZM1.62467 1.62501V4.25001H10.3747V1.62501H1.62467ZM10.3746 11.2501H7.74965C7.2664 11.2501 6.87465 10.8583 6.87465 10.3751V7.7501C6.87465 7.26685 7.2664 6.8751 7.74965 6.8751H10.3746C10.8579 6.8751 11.2496 7.26685 11.2496 7.7501V10.3751C11.2496 10.8583 10.8579 11.2501 10.3746 11.2501ZM7.75035 7.75011V10.3751H10.3754V7.75011H7.75035Z"
      fill="currentColor"
    />
  </svg>
)

export default ReportsIcon
